import { render, staticRenderFns } from "./DisableOrganizationUser.vue?vue&type=template&id=58f27cd3&scoped=true&"
import script from "./DisableOrganizationUser.vue?vue&type=script&lang=js&"
export * from "./DisableOrganizationUser.vue?vue&type=script&lang=js&"
import style0 from "./DisableOrganizationUser.vue?vue&type=style&index=0&id=58f27cd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f27cd3",
  null
  
)

export default component.exports